module.exports = __webpack_public_path__ + "img/chrome_add_cert.2919b28d.png";